// extracted by mini-css-extract-plugin
export default {"wrapper":"users-administration_wrapper__5Ir5d"};